<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M8.64982 15.4H6.45607C5.71049 15.4 5.09055 14.7892 5.24058 14.0588C5.69915 11.8266 7.32299 10 9.99982 10" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10.0001 9.99995C11.5845 9.99995 12.8688 8.71557 12.8688 7.1312C12.8688 5.54683 11.5845 4.26245 10.0001 4.26245C8.41573 4.26245 7.13135 5.54683 7.13135 7.1312C7.13135 8.71557 8.41573 9.99995 10.0001 9.99995Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
    <path d="M14.7921 12.9025C15.1276 12.9025 15.3996 12.6305 15.3996 12.295C15.3996 11.9595 15.1276 11.6875 14.7921 11.6875C14.4566 11.6875 14.1846 11.9595 14.1846 12.295C14.1846 12.6305 14.4566 12.9025 14.7921 12.9025Z" 
    fill="currentColor"/>
    <path d="M14.6236 10.3711C15.7792 10.3711 16.7165 11.3083 16.7165 12.464C16.7163 13.6195 15.7792 14.5562 14.6236 14.5562C14.3997 14.5562 14.1844 14.5198 13.9822 14.4547L12.8978 15.5396C12.7712 15.6663 12.5995 15.7375 12.4204 15.7375H11.3501V14.667C11.3501 14.488 11.4212 14.3164 11.5477 14.1898L12.6322 13.1047C12.5673 12.9027 12.5313 12.6876 12.5313 12.464C12.5313 11.3084 13.468 10.3712 14.6236 10.3711Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'GuestAccessIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>